import { memo, useMemo } from 'react';

const Header = (data: any) => {
    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: data.header }} />
        </>
    )
}
export default memo(Header);